// import "../styles/chatStyle.css";
import React, { useState, useEffect, useRef } from "react";
//import { Client as ConversationsClient } from "@twilio/conversations";
import { Client } from "@twilio/conversations";
import axios from "axios";
import Api from "../../Api/Api.json";
import { useParams } from "react-router-dom";
import {
	Box,
	Button,
	CardContent,
	IconButton,
	TextField,
	Typography,
} from "@mui/material";
import { ArrowUpward } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
// import BottomTab from "./BottomTab";

const UserChat = ({ message, gender }) => {
	return (
		<Box className="flex flex-row gap-2 items-end ml-auto max-w-lg">
			<Box className="bg-gray-200 p-2 rounded-t-xl rounded-l-xl mb-1">
				<Typography
					variant="body1"
					wrap
					sx={{
						wordWrap: "break-word", // For legacy browsers
						overflowWrap: "break-word", // Modern standard
						wordBreak: "break-word", // For non-CJK languages
						hyphens: "auto", // Add hyphens when breaking if supported
					}}
				>
					{message}
				</Typography>
			</Box>

			<img
				className="w-11 h-11 md:w-12 md:h-12 p-1 ml-2 md:ml-4 rounded-full bg-gray-200"
				src={
					gender === "male"
						? "/male_avatar.webp"
						: gender === "female"
						? "/female_avatar.png"
						: "https://i.postimg.cc/s23J2htT/4.png"
				}
				alt="User Avatar"
			/>
		</Box>
	);
};

const AssistantChat = ({ message }) => {
	return (
		<Box className="flex flex-row gap-2 items-end max-w-lg">
			<img
				className="w-11 h-11 md:w-12 md:h-12 p-1 mr-2 md:mr-4 rounded-full bg-gray-200"
				src="https://i.postimg.cc/yNny3NKs/3.png"
				alt="Assistant Avatar"
			/>
			<Box className="bg-gray-200 p-2 rounded-t-xl rounded-r-xl mb-1">
				<Typography
					variant="body1"
					wrap
					sx={{
						wordWrap: "break-word", // For legacy browsers
						overflowWrap: "break-word", // Modern standard
						wordBreak: "break-word", // For non-CJK languages
						hyphens: "auto", // Add hyphens when breaking if supported
					}}
				>
					{message}
				</Typography>
			</Box>
		</Box>
	);
};

const Chat = ({ patient_id }) => {
	const [messages, setMessages] = useState(null);
	const [messageInput, setMessageInput] = useState("");
	const [conversation, setConversation] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [isSending, setIsSending] = useState(false);
	const messagesEndRef = useRef(null);
	//onst identity = prompt("Enter your chat username:");
	const getChatToken = async () => {
		const headers = { headers: { "Content-Type": "application/json" } };
		const url = Api.TELEDOC_PROVIDER_API;
		console.log(patient_id);
		const requestData = {
			task: "getConversationCredForNonPatient",
			patient_id: patient_id,
			identity: "Health Worker",
			timezone: "Asia/Dhaka",
		};
		console.log("calling page data api");
		try {
			const result = await axios.post(url, requestData, headers);
			if (result.data) {
				return {
					token: result.data.body,
					conversationSID: result.data.conv_sid,
				};
			}
		} catch (error) {
			return {
				token: null,
				conversationSID: null,
			};
		}
	};

	const initializeChat = async () => {
		try {
			const { token, conversationSID } = await getChatToken();
			if (!token || !conversationSID) {
				setError("Error initializing chat.");
				return;
			}

			const client = new Client(token);

			client.on("initialized", () => {
				console.log("created client");
			});

			client.on("initFailed", ({ error }) => {
				console.log("client init failed");
			});

			const conversation = await client.getConversationBySid(
				conversationSID
			);

			setConversation(conversation);
			setLoading(false);

			// Fetch initial messages
			const fetchedMessages = await conversation.getMessages();
			setMessages(fetchedMessages.items);

			// Remove existing listeners before adding a new one
			conversation.removeAllListeners("messageAdded");

			// Listen for new messages (only once)
			conversation.on("messageAdded", (message) => {
				setMessages((prevMessages) => {
					const isDuplicate = prevMessages.some(
						(msg) => msg.sid === message.sid
					);

					console.log("messageAdded", message);
					return isDuplicate
						? prevMessages
						: [...prevMessages, message];
				});
			});
		} catch (err) {
			console.error("Error initializing chat:", err);
			setError("Error initializing chat.");
		}
	};

	const sendMessage = async () => {
		if (messageInput.trim() === "" || !conversation) return;

		setIsSending(true);
		try {
			await conversation.sendMessage(messageInput);
			setMessageInput("");
		} catch (err) {
			console.error("Error sending message:", err);
		}
		setIsSending(false);
	};

	useEffect(() => {
		initializeChat();
	}, [patient_id]);

	const handleInputChange = (e) => {
		setMessageInput(e.target.value);
	};

	const scrollToBottom = () => {
		if (messagesEndRef.current) {
			messagesEndRef.current.scrollTo({
				top: messagesEndRef.current.scrollHeight,
				behavior: "smooth",
			});
		}
	};

	useEffect(() => {
		scrollToBottom();
	}, [messages]);

	// if (loading) return <div>Loading chat...</div>;
	if (error) return <div>{error}</div>;

	return (
		<div
			className="flex flex-col gap-1"
			style={{
				height: "calc(100vh - 239px)",
			}}
		>
			<CardContent
				className="flex flex-col gap-4 overflow-y-auto h-full"
				ref={messagesEndRef}
			>
				{messages ? (
					messages.map((message, index) => (
						<Box key={index} className="flex flex-col gap-2">
							{message.author === "Health Worker" ? (
								<UserChat message={message.body} />
							) : (
								<AssistantChat message={message.body} />
							)}
						</Box>
					))
				) : (
					<div className="z-40 w-full flex justify-center items-center h-full">
						<div className="border-[6px] border-solid border-zinc-200 rounded-full border-t-[8px] border-t-[#3F4A9C] w-14 h-14 animate-spin"></div>
					</div>
				)}
			</CardContent>

			<Box className="w-full">
				<Box className="grid grid-cols-12 gap-2 p-0 items-center">
					<TextField
						value={messageInput}
						onChange={handleInputChange}
						variant="filled"
						fullWidth
						placeholder="আপনার বার্তা..."
						className="bg-white col-span-11"
						onKeyDown={(e) => {
							if (e.key === "Enter" && !isSending) {
								e.preventDefault(); // Prevents form submission (if inside a form)
								sendMessage(); // Calls the next function
							}
						}}
						// disabled={isSending}
					/>
					<button
						className={`btn btn-primary ${
							isSending ? "loading" : ""
						} !rounded-md h-full`}
					>
						<ArrowUpward />
					</button>
				</Box>
			</Box>

			{/* <BottomTab /> */}
		</div>
	);
};

export default Chat;
